export default {"src":"/_next/static/media/order.5642dc2d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};